module.exports = __webpack_public_path__ + "img/logo-horizontal.40d77808.png";